// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  api_url: 'https://t5.allianz.com.tw/WSAZ/Main/ProcessReq_V2',
  // 錯誤回報網址
  error_report_url: 'https://esuat.allianz.com.tw/service/eProWebService/UserReport.aspx?SystemID=100',
  key: {
    getFormulaConfigs: 'lzoSAZkZWsmpOToWcVesZDNWRSKtWHjlRQBkLmUF',
    fillWPDForm: 'TioTHWDTVXOamKZydbrMUPHtxaWztxPXkVQwNQBu',
    verifyKey: 'wTwVHtxQWsGmrKYhlppTPrQyGTFOGiemsshhVSbF',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
